import { TableCell } from '@mui/material';
import Link from '@mui/material/Link';

import { ColumnInterface, GenericObject } from '@app/components/common/Table/DefaultTable/types';

interface LinkCellProps {
  row: GenericObject;
  column: ColumnInterface;
}

export const LinkSameBrowserTabCell = ({ row, column }: LinkCellProps) => {
  return (
    <TableCell align="left">
      <Link target="_self" href={column.getLink ? column.getLink(row) : ''} underline="none">
        {column.format ? column.format(row) : ''}
      </Link>
    </TableCell>
  );
};
